import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_BREAKOUT_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import usePanelDataService from '../../../services/PanelDataService';
import BusinessServiceDetail from '../bs-detail-panel/BusinessServiceDetail';
import { businessServiceFilterId, timeRangeFilterId } from '../../filters';

const title = t`Business Service Status`;

const countsSource = {
    url: '/query/table',
    params: {
        type: 'businessservice',
        metrics: [
            'status',
            'bsServerCounts',
            'bsDeviceCounts',
            'bsTestCounts',
            'bsTestExperience',
            'bsStatusServers',
            'bsStatusDevices',
        ],
        renderAsEntity: 'true',
        trends: ['status', 'bsDeviceCounts', 'bsServerCounts', 'bsTestCounts'],
    },
};

function BusinessServiceStatusBreakoutPanel() {
    const counts = usePanelDataService(countsSource);

    if (!counts) return null;

    return (
        <>
            <BusinessServiceDetail statusCounts={counts} />
        </>
    );
}

BusinessServiceStatusBreakoutPanel.propTypes = panelPropTypes;

BusinessServiceStatusBreakoutPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    autoHeight: true,
    minContentHeight: 50,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'BusinessServiceStatusBreakout',
    catalogEntry: {
        category: PANEL_CATEGORIES.BUSINESS_SERVICE,
        priority: PANEL_PRIORITIES.STATUS,
        title: t`Business Service Status`,
        description: t`Status counts breakdown for a selected business service`,
        previewImage: STATUS_BREAKOUT_CHART_PANEL_PREVIEW_IMAGE,
    },
    filters: {
        required: [timeRangeFilterId, businessServiceFilterId],
        optional: [],
    },
})(BusinessServiceStatusBreakoutPanel);
